import { Avatar, Chip, chipClasses, styled } from "@mui/material";
import { deepOrange } from "@mui/material/colors";
const CustomDetailChip = styled(Chip)<{
  ownerState: { active?: boolean };
}>(({ theme, ownerState }) => ({
  [`& .${chipClasses.deleteIcon} : hover`]: {
    color: theme.palette.success.dark,
  },
  ...(ownerState.active && {
    [`& .${chipClasses.avatar}`]: {
      background: "rgb(63,94,251)",
      backgroundImage:
        "radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(164,70,252,1) 100%)",
    },
  }),
}));
export default function DetailChip({
  label,
  symbole,
}: {
  label: string;
  symbole: string;
}) {
  return (
    <CustomDetailChip
      sx={{ margin: "8px 4px" }}
      color="secondary"
      variant="outlined"
      avatar={<Avatar sx={{ bgcolor: "red" }}>{symbole}</Avatar>}
      label={label}
      ownerState={{ active: symbole !== "@" }}
    />
  );
}
